/**
 * Tenant organization identity from site configuration (white-label).
 * Never hardcode a brand id — defaults are empty/null until config loads.
 */
import configuration from "react-global-configuration";

/**
 * @param {object} [overrides]
 * @returns {{ orgId: string|null, brandId: string|null, appId: string|null, whiteLabelKey: string|null }}
 */
export function resolveTenantOrganization(overrides) {
  overrides = overrides || {};
  var brandId =
    overrides.brandId ||
    configuration.get("configData.brand_id") ||
    configuration.get("configData.organization_slug") ||
    configuration.get("configData.white_label_key") ||
    configuration.get("configData.site_key") ||
    null;
  var appId =
    overrides.appId ||
    configuration.get("configData.app_id") ||
    configuration.get("configData.app_name") ||
    brandId;
  var whiteLabelKey =
    overrides.whiteLabelKey ||
    configuration.get("configData.white_label_key") ||
    brandId;
  var orgId =
    overrides.orgId ||
    configuration.get("configData.organization_id") ||
    configuration.get("configData.org_id") ||
    null;

  return {
    orgId: orgId != null && orgId !== "" ? String(orgId) : null,
    brandId: brandId != null && brandId !== "" ? String(brandId) : null,
    appId: appId != null && appId !== "" ? String(appId) : null,
    whiteLabelKey:
      whiteLabelKey != null && whiteLabelKey !== ""
        ? String(whiteLabelKey)
        : null,
  };
}

export default resolveTenantOrganization;
